module.exports = __webpack_public_path__ + "static/img/2.f42fb34.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/en/upload/commonality/20251009/2.jpg
// module id = 08AQ
// module chunks = 7